
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13195',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13195",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.718",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9938",
  "foundations-components": "static-1.8465",
  "foundations-components-legacy": "static-1.1490",
  "foundations-theming": "static-1.4754",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.87",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8314",
  "hub-http-shared-msw-handlers": "static-1.10587",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11770",
  "I18n": "static-7.1669",
  "jasmine-runner": "static-1.6735",
  "marketplace-discovery-studio-lib": "static-1.608",
  "marketplace-storefront-base": "static-1.13258",
  "quartz": "static-1.7434",
  "react-dlb": "static-1.88",
  "react-rhumb": "static-1.17000",
  "reactive-variable-buffer-atom": "static-1.3137",
  "reporting-testing-lib": "static-1.10688",
  "reselect": "static-3.10",
  "settings-ui-lib": "static-1.12805",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7603",
  "ui-addon-i18n": "static-1.11428",
  "ui-addon-react-router-dom": "static-1.9819",
  "unified-auth": "static-1.887",
  "unified-auth-core-lib": "static-1.1169",
  "usage-tracker": "static-1.7637",
  "usage-tracker-core": "static-1.7487",
  "customer-data-property-utils": "static-1.8384",
  "hub-http": "static-1.6494",
  "integrations-lib": "static-1.16994",
  "marketplace-ui-common": "static-1.20695",
  "marketplace-ui-install": "static-1.681",
  "property-management-iframe": "static-1.14099",
  "quartz-config": "static-1.1212",
  "quartz-core": "static-1.6653",
  "quartz-routing": "static-1.864",
  "quick-fetch": "static-1.4118",
  "react": "static-7.192",
  "rpc-client-utils": "static-1.4948",
  "ts-schema": "static-1.4280",
  "ui-universal-auth": "static-1.9373",
  "UIComponents": "static-3.8716",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3607",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3711",
  "quartz-webpack": "static-1.3658",
  "bend-plugin-quartz-routing": "static-1.512",
  "ai-components-ui-library": "static-1.9677",
  "codemirror": "static-5.100",
  "foundations-assets": "static-1.5165",
  "pulse": "static-1.910",
  "react-codemirror": "static-1.10921",
  "ui-extensions-preview-lib": "static-1.572",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4734",
  "floating-ui": "static-1.62",
  "foundations-theming-specialty": "static-1.2470",
  "framer-motion": "static-1.77",
  "hs-story-utils": "static-1.9708",
  "react-aria": "static-1.71",
  "react-create-root-preference": "static-1.68",
  "react-select-plus": "static-1.110",
  "react-utils": "static-2.5543",
  "react-virtualized": "static-2.105",
  "StyleGuideUI": "static-3.501",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2594",
  "ui-fonts": "static-1.1032",
  "ui-images": "static-2.1241",
  "bend-plugin-foundations-theming": "static-1.3237",
  "foundations-theming-base": "static-1.3739",
  "stylex": "static-1.39",
  "HeadJS": "static-2.794",
  "hs-test-utils-bend-plugin": "static-1.3425",
  "msw": "static-1.39",
  "testing-library": "static-1.157",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.89",
  "jasmine": "static-4.4596",
  "ui-addon-video-player": "static-1.8984",
  "ai-rendering-library": "static-1.11068",
  "chirp-fetch": "static-1.2177",
  "connections-embed-lib": "static-1.1486",
  "copilot-toolkit": "static-1.11822",
  "feedback-loader": "static-1.29782",
  "laboratory-lib": "static-3.7433",
  "marketplace-embed": "static-1.22871",
  "marketplace-ui-details": "static-1.10590",
  "marketplace-ui-reviews": "static-1.20650",
  "marketplace-ui-tracking": "static-1.14865",
  "sanitize-text": "static-1.8435",
  "usage-tracker-multi": "static-1.6051",
  "usage-tracker-session-replay": "static-1.5323",
  "wootric-nps": "static-1.7187",
  "quartz-head": "static-1.1099",
  "web-vitals": "static-1.13",
  "apollo-link-hub-http": "static-2.4938",
  "immer": "static-1.99",
  "immerable": "static-1.4431",
  "highcharts": "static-8.109",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2673",
  "reporting-data": "static-1.68755",
  "cssUtils": "static-1.902",
  "flux-actions": "static-1.366",
  "react-colorpicker": "static-2.10498",
  "react-dnd-compat": "static-1.4900",
  "redux-observable": "static-1.73",
  "ReduxMessenger": "static-2.10652",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7627",
  "icons": "static-2.679",
  "marketplace-ui-apps-core": "static-1.19227",
  "storybook-react": "static-1.38",
  "trellis-story-utils": "static-1.4791",
  "foundations-components-test-utils": "static-1.5948",
  "quartz-i18n": "static-1.1109",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.429",
  "ads-unified-auth-lib": "static-1.1260",
  "generic-oauth-auth-lib": "static-1.15",
  "google-sheets-integration-lib": "static-1.996",
  "microsoft-drive-auth-lib": "static-1.105",
  "surveymonkey-integration-lib": "static-1.442",
  "slack-ui-library": "static-1.10681",
  "fsm": "static-1.4031",
  "customer-data-objects": "static-1.7972",
  "property-translator": "static-1.5679",
  "hs-locale-management": "static-1.280",
  "frontend-preferences-client": "static-1.8205",
  "hs-promise-utils": "static-1.5878",
  "hubspot-apollo-client": "static-1.5160",
  "integrations-error-boundary-lib": "static-1.14409",
  "integrations-tracking-lib": "static-1.5890",
  "native-integrations-shared-strings": "static-1.8060",
  "sanitize": "static-1.4755",
  "superstore": "static-1.5038",
  "ui-shepherd-react": "static-3.10550",
  "ai-settings-ui-library": "static-1.8303",
  "hub-http-janus": "static-1.875",
  "hubspotter-http": "static-1.4851",
  "immutable-less": "static-1.4931",
  "marketplace-ui-client-types": "static-1.18102",
  "nav-meta": "static-1.30431",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18357",
  "ui-product-approvals-common": "static-1.994",
  "ai-studio-lib": "static-1.12420",
  "hubspot-prosemirror": "static-1.18937",
  "integrations-reconnect-lib": "static-1.459",
  "ui-addon-iframeable": "static-1.9360",
  "ui-addon-integrations-directory-panel": "static-2.8307",
  "ui-product-approvals": "static-1.29099",
  "ui-tool-access": "static-1.10436",
  "inbound-db-properties-service-client": "static-1.4043",
  "property-management-common": "static-1.6387",
  "opentelemetry-fe-types": "static-1.51",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.31",
  "opentelemetry-fe": "static-1.426",
  "quartz-auth": "static-1.1109",
  "quartz-test": "static-1.1109",
  "quartz-tracking": "static-1.813",
  "trellis-components": "static-1.2613",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.358",
  "HubStyle": "static-2.12077",
  "bender-build-tools": "static-1.3425",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22916",
  "ContentUtils": "static-1.69091",
  "customer-data-objects-ui-components": "static-1.13313",
  "sassPrefix": "static-1.174",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.413",
  "batch-promise": "static-1.1825",
  "event-emitter": "static-1.1235",
  "fast-json-patch": "static-1.68",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5741",
  "magpie-types": "static-1.5201",
  "stylex-utils": "static-1.138",
  "trellis-theming": "static-1.1256",
  "avatar-components": "static-1.2766",
  "breeze-engine-core": "static-1.961",
  "breeze-onboarding-components": "static-1.683",
  "customer-data-filters-ui": "static-1.40866",
  "customer-data-reference-ui-components": "static-1.13460",
  "embedded-academy-lib": "static-1.15475",
  "ExportDialog": "static-6.10659",
  "global-styles-ai-lib": "static-1.53",
  "highlight.js": "static-1.84",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42006",
  "reporting-snowflake": "static-1.57372",
  "reporting-ui-components": "static-2.66025",
  "reporting-visualizations": "static-1.60830",
  "trial-components-library": "static-1.14080",
  "ui-addon-teams": "static-1.21888",
  "upgrade-components-lib": "static-1.495",
  "navigation-components": "static-1.18794",
  "breeze-engine-lib": "static-1.1683",
  "simple-logging-lib": "static-1.3332",
  "fail-safe": "static-1.235",
  "app-governance-lib": "static-1.2358",
  "developer-experience-shared-components": "static-1.10786",
  "purchase-motions-components": "static-1.6339",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.10187",
  "usage-tracker-anonymous": "static-1.6054",
  "usage-tracker-public": "static-1.7448",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3982",
  "reference-resolvers": "static-1.8464",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4199",
  "hubspot-apollo-cache": "static-1.619",
  "universal-page-editor-lib": "static-1.3289",
  "final-form": "static-1.76",
  "redux-toolkit": "static-1.76",
  "simple-data-table": "static-1.3502",
  "atom": "static-1.5367",
  "merchandise-lib": "static-1.276",
  "salesImages": "static-1.545",
  "ui-addon-draggable": "static-3.5040",
  "content-assistance-lib": "static-1.8176",
  "content-media-capture": "static-1.5398",
  "customer-data-ui-utilities": "static-1.10110",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24447",
  "growth-payments-core": "static-1.26146",
  "knowledge-content-types": "static-1.8638",
  "PatternValidationJS": "static-1.3176",
  "payment-link-components": "static-1.24139",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20280",
  "ui-addon-emoji-picker": "static-1.10167",
  "ui-business-units-lib": "static-1.9369",
  "video-components-external": "static-1.12121",
  "video-data-lib": "static-1.35779",
  "navigation-messaging": "static-1.8121",
  "collaboration-sidebar": "static-1.58686",
  "crm-component-utils": "static-1.39801",
  "crm-properties-common-lib": "static-1.6171",
  "customer-data-properties": "static-1.52533",
  "external-options-client-types": "static-1.4326",
  "framework-data-schema-resolvers": "static-1.7175",
  "property-value-citations": "static-1.3147",
  "reference-resolvers-lite": "static-1.8383",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10585",
  "base-ui": "static-1.20",
  "react-day-picker": "static-1.8",
  "tanstack-virtual": "static-1.36",
  "cms-field-types": "static-1.5097",
  "content-icons-ui": "static-1.2346",
  "idb-keyval": "static-1.49",
  "reactive-lib": "static-1.1001",
  "breeze-artifacts-sdk": "static-1.281",
  "onboarding-journeys-lib": "static-1.887",
  "onboarding-scopes": "static-1.6736",
  "conversations-skeleton-state": "static-1.7527",
  "crm-message-bus": "static-1.43724",
  "customer-data-filters-ui-msw-helpers": "static-1.23301",
  "events-data-lib": "static-1.526",
  "FormUrlGenerator": "static-2.5010",
  "framework-builder-read-service-client": "static-1.4208",
  "hs-resources": "static-1.474",
  "multi-account-reference-resolvers": "static-1.1285",
  "onboarding-tours": "static-1.17092",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14433",
  "academy-common-lib": "static-1.14935",
  "dashboard-lib": "static-1.82757",
  "getting-started-shared-tasks": "static-1.19203",
  "hubspot-prosemirror-plugins": "static-1.18929",
  "share-with-third-party-component-lib": "static-1.8987",
  "ui-asset-management-lib": "static-1.11379",
  "user-context": "static-1.5402",
  "reporting-plugins": "static-1.10724",
  "reporting-reports": "static-1.68432",
  "hubs-service-types": "static-1.1539",
  "purchase-motions-api": "static-1.6342",
  "signup-constants": "static-1.19595",
  "nest": "static-1.517",
  "breeze-engine-chat-components": "static-1.661",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.186",
  "framework-listing-lib": "static-2.29459",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31390",
  "apps-service-types": "static-1.4021",
  "oauth-service-types": "static-1.4519",
  "signup-ui-url-generator": "static-2.8343",
  "onboarding-tours-client": "static-1.5307",
  "one-click-checkout": "static-1.360",
  "platform-infra-nav-components": "static-1.7880",
  "subscription-experience-data-types": "static-1.15237",
  "crm-record-cards-service-types": "static-1.3773",
  "location-customization-utils-lib": "static-1.10064",
  "redux-thunk": "static-2.78",
  "react-flip-move": "static-1.76",
  "ui-coaching-tips": "static-1.29273",
  "content-media-composition-data-lib": "static-1.13202",
  "fix-webm-duration": "static-1.28",
  "notification-sounds": "static-1.4708",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.684",
  "ui-addon-opt": "static-4.8645",
  "commerce-tours-lib": "static-1.6589",
  "growth-onboarding-reliability": "static-1.5362",
  "sales-checkout-service-client": "static-1.3812",
  "data-token-picker": "static-1.16862",
  "FileManagerLib": "static-1.40087",
  "content-media-compositions": "static-2.17209",
  "media-bridge-lib": "static-1.19382",
  "chatspot-widget-iframe": "static-1.22907",
  "collaboration-sidebar-common": "static-1.3483",
  "marketing-platform-lib": "static-1.7152",
  "card-properties-lib": "static-1.44976",
  "commerce-subscription-lib": "static-1.37742",
  "crm-actions": "static-1.6634",
  "crm-cards-sdk": "static-1.44521",
  "customer-data-properties-shared-msw-handlers": "static-1.9914",
  "customer-data-tracking": "static-1.7164",
  "calling-global-api": "static-1.65553",
  "calling-internal-common": "static-1.31599",
  "calling-lifecycle-internal": "static-1.66935",
  "calling-lifecycle-messages": "static-1.59229",
  "commerce-products-lib": "static-1.10495",
  "conditional-properties-service-client": "static-1.3999",
  "crm-index-visualization-core": "static-1.4520",
  "crm-links": "static-1.6612",
  "crm-pipelines-api-client-types": "static-1.4334",
  "formula-editor": "static-1.14729",
  "google-libphonenumber": "static-1.43",
  "inbounddb-objects-service-types": "static-1.4413",
  "meetings-icalendar-utils-lib": "static-1.917",
  "multi-currency-client-types": "static-1.3895",
  "object-builder-ui-client": "static-1.49632",
  "pipeline-validation-client-types": "static-1.4168",
  "smart-data-capture-core": "static-1.107",
  "smart-property-lib": "static-1.8251",
  "tiered-pricing": "static-1.1926",
  "topics-actions-lib": "static-1.447",
  "ui-addon-form-validation": "static-1.11264",
  "zustand": "static-1.83",
  "fdsr-migration-layer": "static-1.294",
  "framework-data-schema-quick-fetch": "static-1.7080",
  "restore-request-side-panel-lib": "static-1.1634",
  "growth-data-modal": "static-1.5868",
  "growth-onboarding-confetti": "static-1.3343",
  "growth-onboarding-next-action-utils": "static-1.2655",
  "onboarding-tours-utils": "static-1.1159",
  "ui-shepherd-tracker": "static-1.7931",
  "academy-service-client": "static-1.3969",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39946",
  "SafeStorage": "static-1.4684",
  "video-embed": "static-1.36613",
  "redux-actions": "static-3.69",
  "EmailSignatureEditor": "static-1.24974",
  "viral-links-lib": "static-1.7357",
  "nested-table": "static-1.516",
  "timezone-utils": "static-2.5528",
  "getting-started-shared-tasks-store": "static-1.18321",
  "campaign-roi-lib": "static-1.10159",
  "campaigns-utils-lib": "static-1.3487",
  "ui-addon-calendars": "static-2.5611",
  "customer-data-views-management": "static-1.25990",
  "framework-data-table": "static-2.12515",
  "nudge-client-utils": "static-1.3128",
  "nudge-custom-ui-functions": "static-1.1465",
  "switchboard-lib": "static-1.498",
  "access-check-ui-lib": "static-1.1550",
  "app-users-service-client": "static-1.5901",
  "app-users-service-types": "static-1.5309",
  "mini-checkout-client": "static-1.27455",
  "onboarding-utils": "static-1.5647",
  "permissions-shared-i18n-strings-fe": "static-1.2119",
  "ui-coaching-tips-shared-config": "static-1.29258",
  "checkout-sdk": "static-3.24298",
  "payment-method-components": "static-1.7131",
  "touchless-buying-components": "static-1.6166",
  "upgrade-catalog-service-types": "static-1.3752",
  "edison-service-client-types": "static-1.674",
  "growth-onboarding-feedback-components": "static-1.6866",
  "audio-components": "static-1.6318",
  "FileManagerImages": "static-1.37598",
  "video-components": "static-1.14123",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92789",
  "customer-data-sidebar": "static-2.46705",
  "enrichment-lib": "static-1.294",
  "ui-addon-draggable-compat": "static-2.4547",
  "universal-record-utils-lib": "static-1.1845",
  "commerce-billing-lib": "static-1.20128",
  "commerce-shared-components-lib": "static-1.19191",
  "commerce-tools-ui-lib": "static-1.11012",
  "crm-fe-perf": "static-1.23184",
  "calling-error-reporting": "static-1.31606",
  "shared-worker-versioning": "static-1.11323",
  "calling-usage-tracker": "static-1.6818",
  "voice-sms-access-library": "static-1.1990",
  "commerce-permissions": "static-1.1059",
  "products-iframe-lib": "static-1.8558",
  "products-ui-components-shared-msw-handlers": "static-1.10969",
  "crm-index-associations-lib": "static-1.6724",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10670",
  "sales-views-client-types": "static-1.4538",
  "bark-lib": "static-1.16794",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.623",
  "policy-lib": "static-1.7083",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10733",
  "onboarding-data-sync-lib": "static-1.2483",
  "growth-onboarding-next-action-components": "static-1.2683",
  "user-context-client": "static-1.4790",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.59",
  "urlinator": "static-1.4814",
  "outpost": "static-1.4439",
  "draft-convert": "static-2.78",
  "draft-extend": "static-3.81",
  "draft-js": "static-5.83",
  "draft-plugins": "static-2.22132",
  "sales-email-signature-service-client": "static-1.4126",
  "ts-utils-lib": "static-1.431",
  "crm-export-dialog": "static-1.6564",
  "crm-view-components": "static-1.1077",
  "react-beautiful-dnd": "static-1.68",
  "customer-data-associations": "static-1.7609",
  "tasks-actions-lib": "static-1.90",
  "nudge-custom-function-registry": "static-1.2885",
  "nudge-renderer-utils": "static-1.3204",
  "whisper-core-api": "static-1.7291",
  "InboxConnectUtils": "static-4.15526",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46808",
  "hub-http-rxjs": "static-1.839",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4271",
  "company-details-components": "static-1.6484",
  "react-performance-metrics-lib": "static-1.836",
  "pricing-pages-ui-components": "static-1.15726",
  "quote-checkout-service-types": "static-1.3736",
  "social-insights-client-types": "static-1.22705",
  "crm_universal": "static-1.22472",
  "customer-data-email": "static-1.18502",
  "card-payment-highlight-lib": "static-1.37943",
  "commerce-contract-lib": "static-1.13275",
  "invoices-highlight-card-lib": "static-1.55686",
  "orders-highlight-card-lib": "static-1.22160",
  "products-highlight-card-lib": "static-1.18778",
  "quotes-highlight-card-lib": "static-1.72798",
  "crm-source-interpretation-lib": "static-1.5611",
  "data-agent-utils": "static-1.356",
  "crm-object-search-query-utilities": "static-1.10164",
  "utility-belt": "static-1.2815",
  "payments-enrollment-embed-lib": "static-1.23763",
  "stripe-embedded-components": "static-1.7972",
  "customer-data-rte": "static-1.33617",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6246",
  "payments-post-enroll-local-storage-lib": "static-1.5388",
  "qrcode-generator": "static-1.74",
  "quotes-client-types": "static-1.38888",
  "calling-orchestration-schema": "static-1.36767",
  "react-reducer-toolkit": "static-1.16332",
  "meetings-connect-utils-lib": "static-1.7891",
  "hub-http-contrib": "static-1.3320",
  "ui-addon-sales-email": "static-1.5495",
  "access-control-lib": "static-1.10717",
  "EmailComponents": "static-1.55515",
  "EmailData": "static-1.54193",
  "redux-less": "static-2.9761",
  "company-details-service-types": "static-1.4221",
  "segments-query-core": "static-1.1704",
  "pricing-pages-api": "static-1.15591",
  "sequences-lib": "static-1.8510",
  "ui-gdpr-components": "static-1.10625",
  "products-ui-components": "static-1.41013",
  "accounting-integrations-ui-components": "static-1.7511",
  "invoices-ui-lib": "static-1.55702",
  "commerce-products-api": "static-1.2670",
  "invoices-iframe-lib": "static-1.57760",
  "quotes-modal-lib": "static-1.103476",
  "quotes-ui-lib": "static-1.81519",
  "stripe-connect-js": "static-1.75",
  "draft-content-plugins": "static-1.28875",
  "ContentComponents": "static-2.72047",
  "ContentData": "static-1.69166",
  "marketing-contacts-lib": "static-1.10982",
  "marketing-email-service-types": "static-1.2082",
  "messaging-editing-lib": "static-1.47097",
  "messaging-usage-based-billing-components-lib": "static-1.1959",
  "automation-ui-source-apps": "static-1.19652",
  "automation-ui-types": "static-1.20570",
  "messaging-types-lib": "static-1.46834",
  "onboarding-settings-client": "static-1.4790",
  "sequences-client-types-lib": "static-1.8367",
  "commerce-tax-lib": "static-1.819",
  "price-books-api": "static-1.1701",
  "price-books-components": "static-1.1759",
  "property-description-translator": "static-1.4122",
  "ramp-editor": "static-1.860",
  "commerce-analytics-service-client": "static-1.3800",
  "totals-ui-components": "static-1.24261",
  "SalesContentIndexUI": "static-3.9605",
  "advanced-menus-core": "static-1.15552",
  "advanced-menus-lib": "static-1.12428",
  "automation-ui-ubb": "static-1.6486",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7618",
  "data-token-views": "static-1.16843",
  "forms-utils-lib": "static-1.13069",
  "payments-embed-points-lib": "static-1.13559",
  "react-tinymce": "static-1.55943",
  "simple-menus-core": "static-1.15551",
  "simple-menus-lib": "static-1.17068",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55069",
  "tinymce-data": "static-1.41154",
  "tinymce-plugins": "static-1.58183",
  "tinymce-themes": "static-1.57039",
  "ui-brand-identity-lib": "static-1.16412",
  "ui-memberships-settings-lib": "static-1.34809",
  "videoconference-integration-components": "static-1.7239",
  "marketing-contacts-client": "static-1.7793",
  "mc-hard-limits-client-types": "static-1.187",
  "automation-applications-service-types": "static-1.3651",
  "automation-platform-service-types": "static-1.2662",
  "ContentEditorUI": "static-2.77870",
  "short-messages-app-service-client": "static-1.4196",
  "web-interactives-components": "static-1.14223",
  "web-interactives-data": "static-1.14224",
  "messaging-shared-utils-lib": "static-1.1408",
  "messaging-user-info-utils-lib": "static-1.1578",
  "email-portal-health-service-types": "static-1.1261",
  "line-items-api": "static-1.1072",
  "commerce-totals-service-types": "static-1.4019",
  "FireAlarmUi": "static-1.4707",
  "sales-templates-service-types-lib": "static-1.4371",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22506",
  "automation-ui-usage-tracking": "static-1.21969",
  "data-studio-ubb": "static-1.3477",
  "interframe": "static-3.5037",
  "layout-dnd-components": "static-1.12940",
  "layout-dnd-utils": "static-1.11915",
  "NamespacedHubStyle": "static-2.9250",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27620",
  "content-management-data-lib": "static-1.5929",
  "copilot-plugins": "static-1.11794",
  "cta-picker": "static-1.37052",
  "customer-agent-discovery-components-lib": "static-1.3883",
  "editor-components": "static-1.13625",
  "editor-iframe-lib": "static-1.8773",
  "error-messaging-js": "static-1.5478",
  "FormsCommonComponents": "static-1.86528",
  "layout-data-lib": "static-1.10240",
  "pictos": "static-7.190",
  "react-transition-group": "static-2.71",
  "redux-request-state": "static-1.10930",
  "SharedLegalStrings": "static-1.2029",
  "smart-content-core": "static-1.43142",
  "smart-content-lib": "static-1.43795",
  "social-composer-lib": "static-1.60242",
  "structured-content-lib": "static-1.25884",
  "theme-previewer-lib": "static-1.53913",
  "tinymce-copilot": "static-1.17137",
  "xray-recommendation-lib": "static-1.8241",
  "automation-ui-routing": "static-1.21927",
  "sql-reporting-client-types": "static-1.5882",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42761",
  "reporting-enablement": "static-1.23797",
  "forms-ai-lib": "static-1.4738",
  "codemirror-dlb": "static-1.59429",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6720",
  "report-customization-components": "static-1.13878",
  "data-quality-ui-library": "static-1.13763",
  "reporting-filters": "static-1.973",
  "reporting-insights-lib": "static-1.2534",
  "segments-client-types": "static-1.11469"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13195",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.718",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9938",
  "foundations-components": "/foundations-components/static-1.8465",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1490",
  "foundations-theming": "/foundations-theming/static-1.4754",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.87",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8314",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10587",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11770",
  "I18n": "/I18n/static-7.1669",
  "jasmine-runner": "/jasmine-runner/static-1.6735",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.608",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13258",
  "quartz": "/quartz/static-1.7434",
  "react-dlb": "/react-dlb/static-1.88",
  "react-rhumb": "/react-rhumb/static-1.17000",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3137",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10688",
  "reselect": "/reselect/static-3.10",
  "settings-ui-lib": "/settings-ui-lib/static-1.12805",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7603",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11428",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9819",
  "unified-auth": "/unified-auth/static-1.887",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1169",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8384",
  "hub-http": "/hub-http/static-1.6494",
  "integrations-lib": "/integrations-lib/static-1.16994",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20695",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.681",
  "property-management-iframe": "/property-management-iframe/static-1.14099",
  "quartz-config": "/quartz-config/static-1.1212",
  "quartz-core": "/quartz-core/static-1.6653",
  "quartz-routing": "/quartz-routing/static-1.864",
  "quick-fetch": "/quick-fetch/static-1.4118",
  "react": "/react/static-7.192",
  "rpc-client-utils": "/rpc-client-utils/static-1.4948",
  "ts-schema": "/ts-schema/static-1.4280",
  "ui-universal-auth": "/ui-universal-auth/static-1.9373",
  "UIComponents": "/UIComponents/static-3.8716",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3607",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3711",
  "quartz-webpack": "/quartz-webpack/static-1.3658",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.512",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9677",
  "codemirror": "/codemirror/static-5.100",
  "foundations-assets": "/foundations-assets/static-1.5165",
  "pulse": "/pulse/static-1.910",
  "react-codemirror": "/react-codemirror/static-1.10921",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.572",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4734",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2470",
  "framer-motion": "/framer-motion/static-1.77",
  "hs-story-utils": "/hs-story-utils/static-1.9708",
  "react-aria": "/react-aria/static-1.71",
  "react-create-root-preference": "/react-create-root-preference/static-1.68",
  "react-select-plus": "/react-select-plus/static-1.110",
  "react-utils": "/react-utils/static-2.5543",
  "react-virtualized": "/react-virtualized/static-2.105",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2594",
  "ui-fonts": "/ui-fonts/static-1.1032",
  "ui-images": "/ui-images/static-2.1241",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3237",
  "foundations-theming-base": "/foundations-theming-base/static-1.3739",
  "stylex": "/stylex/static-1.39",
  "HeadJS": "/HeadJS/static-2.794",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3425",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.157",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.89",
  "jasmine": "/jasmine/static-4.4596",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8984",
  "ai-rendering-library": "/ai-rendering-library/static-1.11068",
  "chirp-fetch": "/chirp-fetch/static-1.2177",
  "connections-embed-lib": "/connections-embed-lib/static-1.1486",
  "copilot-toolkit": "/copilot-toolkit/static-1.11822",
  "feedback-loader": "/feedback-loader/static-1.29782",
  "laboratory-lib": "/laboratory-lib/static-3.7433",
  "marketplace-embed": "/marketplace-embed/static-1.22871",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10590",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20650",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14865",
  "sanitize-text": "/sanitize-text/static-1.8435",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6051",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "wootric-nps": "/wootric-nps/static-1.7187",
  "quartz-head": "/quartz-head/static-1.1099",
  "web-vitals": "/web-vitals/static-1.13",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4938",
  "immer": "/immer/static-1.99",
  "immerable": "/immerable/static-1.4431",
  "highcharts": "/highcharts/static-8.109",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2673",
  "reporting-data": "/reporting-data/static-1.68755",
  "cssUtils": "/cssUtils/static-1.902",
  "flux-actions": "/flux-actions/static-1.366",
  "react-colorpicker": "/react-colorpicker/static-2.10498",
  "react-dnd-compat": "/react-dnd-compat/static-1.4900",
  "redux-observable": "/redux-observable/static-1.73",
  "ReduxMessenger": "/ReduxMessenger/static-2.10652",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "icons": "/icons/static-2.679",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19227",
  "storybook-react": "/storybook-react/static-1.38",
  "trellis-story-utils": "/trellis-story-utils/static-1.4791",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5948",
  "quartz-i18n": "/quartz-i18n/static-1.1109",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.429",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1260",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.15",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.996",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.105",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.442",
  "slack-ui-library": "/slack-ui-library/static-1.10681",
  "fsm": "/fsm/static-1.4031",
  "customer-data-objects": "/customer-data-objects/static-1.7972",
  "property-translator": "/property-translator/static-1.5679",
  "hs-locale-management": "/hs-locale-management/static-1.280",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8205",
  "hs-promise-utils": "/hs-promise-utils/static-1.5878",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5160",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14409",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5890",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8060",
  "sanitize": "/sanitize/static-1.4755",
  "superstore": "/superstore/static-1.5038",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10550",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8303",
  "hub-http-janus": "/hub-http-janus/static-1.875",
  "hubspotter-http": "/hubspotter-http/static-1.4851",
  "immutable-less": "/immutable-less/static-1.4931",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18102",
  "nav-meta": "/nav-meta/static-1.30431",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18357",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.994",
  "ai-studio-lib": "/ai-studio-lib/static-1.12420",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18937",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.459",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9360",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8307",
  "ui-product-approvals": "/ui-product-approvals/static-1.29099",
  "ui-tool-access": "/ui-tool-access/static-1.10436",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4043",
  "property-management-common": "/property-management-common/static-1.6387",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.51",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.31",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.426",
  "quartz-auth": "/quartz-auth/static-1.1109",
  "quartz-test": "/quartz-test/static-1.1109",
  "quartz-tracking": "/quartz-tracking/static-1.813",
  "trellis-components": "/trellis-components/static-1.2613",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.358",
  "HubStyle": "/HubStyle/static-2.12077",
  "bender-build-tools": "/bender-build-tools/static-1.3425",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22916",
  "ContentUtils": "/ContentUtils/static-1.69091",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13313",
  "sassPrefix": "/sassPrefix/static-1.174",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.413",
  "batch-promise": "/batch-promise/static-1.1825",
  "event-emitter": "/event-emitter/static-1.1235",
  "fast-json-patch": "/fast-json-patch/static-1.68",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5741",
  "magpie-types": "/magpie-types/static-1.5201",
  "stylex-utils": "/stylex-utils/static-1.138",
  "trellis-theming": "/trellis-theming/static-1.1256",
  "avatar-components": "/avatar-components/static-1.2766",
  "breeze-engine-core": "/breeze-engine-core/static-1.961",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.683",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40866",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13460",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15475",
  "ExportDialog": "/ExportDialog/static-6.10659",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.53",
  "highlight.js": "/highlight.js/static-1.84",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42006",
  "reporting-snowflake": "/reporting-snowflake/static-1.57372",
  "reporting-ui-components": "/reporting-ui-components/static-2.66025",
  "reporting-visualizations": "/reporting-visualizations/static-1.60830",
  "trial-components-library": "/trial-components-library/static-1.14080",
  "ui-addon-teams": "/ui-addon-teams/static-1.21888",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.495",
  "navigation-components": "/navigation-components/static-1.18794",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1683",
  "simple-logging-lib": "/simple-logging-lib/static-1.3332",
  "fail-safe": "/fail-safe/static-1.235",
  "app-governance-lib": "/app-governance-lib/static-1.2358",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10786",
  "purchase-motions-components": "/purchase-motions-components/static-1.6339",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10187",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
  "usage-tracker-public": "/usage-tracker-public/static-1.7448",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3982",
  "reference-resolvers": "/reference-resolvers/static-1.8464",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4199",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.619",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3289",
  "final-form": "/final-form/static-1.76",
  "redux-toolkit": "/redux-toolkit/static-1.76",
  "simple-data-table": "/simple-data-table/static-1.3502",
  "atom": "/atom/static-1.5367",
  "merchandise-lib": "/merchandise-lib/static-1.276",
  "salesImages": "/salesImages/static-1.545",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5040",
  "content-assistance-lib": "/content-assistance-lib/static-1.8176",
  "content-media-capture": "/content-media-capture/static-1.5398",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10110",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24447",
  "growth-payments-core": "/growth-payments-core/static-1.26146",
  "knowledge-content-types": "/knowledge-content-types/static-1.8638",
  "PatternValidationJS": "/PatternValidationJS/static-1.3176",
  "payment-link-components": "/payment-link-components/static-1.24139",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20280",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10167",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9369",
  "video-components-external": "/video-components-external/static-1.12121",
  "video-data-lib": "/video-data-lib/static-1.35779",
  "navigation-messaging": "/navigation-messaging/static-1.8121",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58686",
  "crm-component-utils": "/crm-component-utils/static-1.39801",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6171",
  "customer-data-properties": "/customer-data-properties/static-1.52533",
  "external-options-client-types": "/external-options-client-types/static-1.4326",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7175",
  "property-value-citations": "/property-value-citations/static-1.3147",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8383",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10585",
  "base-ui": "/base-ui/static-1.20",
  "react-day-picker": "/react-day-picker/static-1.8",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "cms-field-types": "/cms-field-types/static-1.5097",
  "content-icons-ui": "/content-icons-ui/static-1.2346",
  "idb-keyval": "/idb-keyval/static-1.49",
  "reactive-lib": "/reactive-lib/static-1.1001",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.281",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.887",
  "onboarding-scopes": "/onboarding-scopes/static-1.6736",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7527",
  "crm-message-bus": "/crm-message-bus/static-1.43724",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23301",
  "events-data-lib": "/events-data-lib/static-1.526",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5010",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4208",
  "hs-resources": "/hs-resources/static-1.474",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1285",
  "onboarding-tours": "/onboarding-tours/static-1.17092",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14433",
  "academy-common-lib": "/academy-common-lib/static-1.14935",
  "dashboard-lib": "/dashboard-lib/static-1.82757",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19203",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18929",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8987",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11379",
  "user-context": "/user-context/static-1.5402",
  "reporting-plugins": "/reporting-plugins/static-1.10724",
  "reporting-reports": "/reporting-reports/static-1.68432",
  "hubs-service-types": "/hubs-service-types/static-1.1539",
  "purchase-motions-api": "/purchase-motions-api/static-1.6342",
  "signup-constants": "/signup-constants/static-1.19595",
  "nest": "/nest/static-1.517",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.661",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.186",
  "framework-listing-lib": "/framework-listing-lib/static-2.29459",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31390",
  "apps-service-types": "/apps-service-types/static-1.4021",
  "oauth-service-types": "/oauth-service-types/static-1.4519",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8343",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5307",
  "one-click-checkout": "/one-click-checkout/static-1.360",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7880",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15237",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3773",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10064",
  "redux-thunk": "/redux-thunk/static-2.78",
  "react-flip-move": "/react-flip-move/static-1.76",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29273",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13202",
  "fix-webm-duration": "/fix-webm-duration/static-1.28",
  "notification-sounds": "/notification-sounds/static-1.4708",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.684",
  "ui-addon-opt": "/ui-addon-opt/static-4.8645",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6589",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5362",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3812",
  "data-token-picker": "/data-token-picker/static-1.16862",
  "FileManagerLib": "/FileManagerLib/static-1.40087",
  "content-media-compositions": "/content-media-compositions/static-2.17209",
  "media-bridge-lib": "/media-bridge-lib/static-1.19382",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22907",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3483",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7152",
  "card-properties-lib": "/card-properties-lib/static-1.44976",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37742",
  "crm-actions": "/crm-actions/static-1.6634",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44521",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9914",
  "customer-data-tracking": "/customer-data-tracking/static-1.7164",
  "calling-global-api": "/calling-global-api/static-1.65553",
  "calling-internal-common": "/calling-internal-common/static-1.31599",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66935",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59229",
  "commerce-products-lib": "/commerce-products-lib/static-1.10495",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3999",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4520",
  "crm-links": "/crm-links/static-1.6612",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4334",
  "formula-editor": "/formula-editor/static-1.14729",
  "google-libphonenumber": "/google-libphonenumber/static-1.43",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4413",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.917",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3895",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49632",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4168",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.107",
  "smart-property-lib": "/smart-property-lib/static-1.8251",
  "tiered-pricing": "/tiered-pricing/static-1.1926",
  "topics-actions-lib": "/topics-actions-lib/static-1.447",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11264",
  "zustand": "/zustand/static-1.83",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.294",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7080",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1634",
  "growth-data-modal": "/growth-data-modal/static-1.5868",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3343",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2655",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1159",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7931",
  "academy-service-client": "/academy-service-client/static-1.3969",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39946",
  "SafeStorage": "/SafeStorage/static-1.4684",
  "video-embed": "/video-embed/static-1.36613",
  "redux-actions": "/redux-actions/static-3.69",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24974",
  "viral-links-lib": "/viral-links-lib/static-1.7357",
  "nested-table": "/nested-table/static-1.516",
  "timezone-utils": "/timezone-utils/static-2.5528",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18321",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10159",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3487",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5611",
  "customer-data-views-management": "/customer-data-views-management/static-1.25990",
  "framework-data-table": "/framework-data-table/static-2.12515",
  "nudge-client-utils": "/nudge-client-utils/static-1.3128",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1465",
  "switchboard-lib": "/switchboard-lib/static-1.498",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1550",
  "app-users-service-client": "/app-users-service-client/static-1.5901",
  "app-users-service-types": "/app-users-service-types/static-1.5309",
  "mini-checkout-client": "/mini-checkout-client/static-1.27455",
  "onboarding-utils": "/onboarding-utils/static-1.5647",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2119",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29258",
  "checkout-sdk": "/checkout-sdk/static-3.24298",
  "payment-method-components": "/payment-method-components/static-1.7131",
  "touchless-buying-components": "/touchless-buying-components/static-1.6166",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3752",
  "edison-service-client-types": "/edison-service-client-types/static-1.674",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6866",
  "audio-components": "/audio-components/static-1.6318",
  "FileManagerImages": "/FileManagerImages/static-1.37598",
  "video-components": "/video-components/static-1.14123",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92789",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46705",
  "enrichment-lib": "/enrichment-lib/static-1.294",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4547",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1845",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20128",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19191",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11012",
  "crm-fe-perf": "/crm-fe-perf/static-1.23184",
  "calling-error-reporting": "/calling-error-reporting/static-1.31606",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11323",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6818",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1990",
  "commerce-permissions": "/commerce-permissions/static-1.1059",
  "products-iframe-lib": "/products-iframe-lib/static-1.8558",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10969",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6724",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10670",
  "sales-views-client-types": "/sales-views-client-types/static-1.4538",
  "bark-lib": "/bark-lib/static-1.16794",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.623",
  "policy-lib": "/policy-lib/static-1.7083",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10733",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2483",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2683",
  "user-context-client": "/user-context-client/static-1.4790",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.59",
  "urlinator": "/urlinator/static-1.4814",
  "outpost": "/outpost/static-1.4439",
  "draft-convert": "/draft-convert/static-2.78",
  "draft-extend": "/draft-extend/static-3.81",
  "draft-js": "/draft-js/static-5.83",
  "draft-plugins": "/draft-plugins/static-2.22132",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4126",
  "ts-utils-lib": "/ts-utils-lib/static-1.431",
  "crm-export-dialog": "/crm-export-dialog/static-1.6564",
  "crm-view-components": "/crm-view-components/static-1.1077",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.68",
  "customer-data-associations": "/customer-data-associations/static-1.7609",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.90",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2885",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3204",
  "whisper-core-api": "/whisper-core-api/static-1.7291",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15526",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46808",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.839",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4271",
  "company-details-components": "/company-details-components/static-1.6484",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.836",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15726",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3736",
  "social-insights-client-types": "/social-insights-client-types/static-1.22705",
  "crm_universal": "/crm_universal/static-1.22472",
  "customer-data-email": "/customer-data-email/static-1.18502",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37943",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13275",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55686",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22160",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18778",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72798",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5611",
  "data-agent-utils": "/data-agent-utils/static-1.356",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10164",
  "utility-belt": "/utility-belt/static-1.2815",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23763",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7972",
  "customer-data-rte": "/customer-data-rte/static-1.33617",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6246",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5388",
  "qrcode-generator": "/qrcode-generator/static-1.74",
  "quotes-client-types": "/quotes-client-types/static-1.38888",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36767",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16332",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7891",
  "hub-http-contrib": "/hub-http-contrib/static-1.3320",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5495",
  "access-control-lib": "/access-control-lib/static-1.10717",
  "EmailComponents": "/EmailComponents/static-1.55515",
  "EmailData": "/EmailData/static-1.54193",
  "redux-less": "/redux-less/static-2.9761",
  "company-details-service-types": "/company-details-service-types/static-1.4221",
  "segments-query-core": "/segments-query-core/static-1.1704",
  "pricing-pages-api": "/pricing-pages-api/static-1.15591",
  "sequences-lib": "/sequences-lib/static-1.8510",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "products-ui-components": "/products-ui-components/static-1.41013",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7511",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55702",
  "commerce-products-api": "/commerce-products-api/static-1.2670",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57760",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103476",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81519",
  "stripe-connect-js": "/stripe-connect-js/static-1.75",
  "draft-content-plugins": "/draft-content-plugins/static-1.28875",
  "ContentComponents": "/ContentComponents/static-2.72047",
  "ContentData": "/ContentData/static-1.69166",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10982",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2082",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47097",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1959",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19652",
  "automation-ui-types": "/automation-ui-types/static-1.20570",
  "messaging-types-lib": "/messaging-types-lib/static-1.46834",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4790",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8367",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.819",
  "price-books-api": "/price-books-api/static-1.1701",
  "price-books-components": "/price-books-components/static-1.1759",
  "property-description-translator": "/property-description-translator/static-1.4122",
  "ramp-editor": "/ramp-editor/static-1.860",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3800",
  "totals-ui-components": "/totals-ui-components/static-1.24261",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9605",
  "advanced-menus-core": "/advanced-menus-core/static-1.15552",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12428",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6486",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7618",
  "data-token-views": "/data-token-views/static-1.16843",
  "forms-utils-lib": "/forms-utils-lib/static-1.13069",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13559",
  "react-tinymce": "/react-tinymce/static-1.55943",
  "simple-menus-core": "/simple-menus-core/static-1.15551",
  "simple-menus-lib": "/simple-menus-lib/static-1.17068",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55069",
  "tinymce-data": "/tinymce-data/static-1.41154",
  "tinymce-plugins": "/tinymce-plugins/static-1.58183",
  "tinymce-themes": "/tinymce-themes/static-1.57039",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16412",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34809",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7239",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7793",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.187",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3651",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2662",
  "ContentEditorUI": "/ContentEditorUI/static-2.77870",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4196",
  "web-interactives-components": "/web-interactives-components/static-1.14223",
  "web-interactives-data": "/web-interactives-data/static-1.14224",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1408",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1578",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1261",
  "line-items-api": "/line-items-api/static-1.1072",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4019",
  "FireAlarmUi": "/FireAlarmUi/static-1.4707",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4371",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22506",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21969",
  "data-studio-ubb": "/data-studio-ubb/static-1.3477",
  "interframe": "/interframe/static-3.5037",
  "layout-dnd-components": "/layout-dnd-components/static-1.12940",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11915",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9250",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27620",
  "content-management-data-lib": "/content-management-data-lib/static-1.5929",
  "copilot-plugins": "/copilot-plugins/static-1.11794",
  "cta-picker": "/cta-picker/static-1.37052",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3883",
  "editor-components": "/editor-components/static-1.13625",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8773",
  "error-messaging-js": "/error-messaging-js/static-1.5478",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86528",
  "layout-data-lib": "/layout-data-lib/static-1.10240",
  "pictos": "/pictos/static-7.190",
  "react-transition-group": "/react-transition-group/static-2.71",
  "redux-request-state": "/redux-request-state/static-1.10930",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2029",
  "smart-content-core": "/smart-content-core/static-1.43142",
  "smart-content-lib": "/smart-content-lib/static-1.43795",
  "social-composer-lib": "/social-composer-lib/static-1.60242",
  "structured-content-lib": "/structured-content-lib/static-1.25884",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53913",
  "tinymce-copilot": "/tinymce-copilot/static-1.17137",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8241",
  "automation-ui-routing": "/automation-ui-routing/static-1.21927",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5882",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42761",
  "reporting-enablement": "/reporting-enablement/static-1.23797",
  "forms-ai-lib": "/forms-ai-lib/static-1.4738",
  "codemirror-dlb": "/codemirror-dlb/static-1.59429",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6720",
  "report-customization-components": "/report-customization-components/static-1.13878",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13763",
  "reporting-filters": "/reporting-filters/static-1.973",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2534",
  "segments-client-types": "/segments-client-types/static-1.11469"
}
};
